import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N0, N30, N30A, N60A, N900 } from '@atlaskit/theme/colors';

import dangerBackgroundGrid from './assets/danger-background-grid.svg';
import warningBackgroundGrid from './assets/warning-background-grid.svg';
import dangerBackgroundGridDark from './assets/dark-danger-background-grid.svg';
import warningBackgroundGridDark from './assets/dark-warning-background-grid.svg';
import lockScreenExperimentBackgroundDark from './assets/dark-lock-screen-experiment-background.svg';
import lockScreenExperimentBackground from './assets/lock-screen-experiment-background.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LockScreenContainer = styled.div({
	position: 'fixed',
	display: 'flex',
	flexDirection: 'column',
	width: '100vw',
	height: '100vh',
	inset: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LockScreenBlanket = styled.div<{ isDarkMode: boolean }>({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'flex-start',
	flex: 1,
	overflow: 'auto',
	// emulate modal which does not follow design system tokens
	padding: `60px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundImage: ({ isDarkMode }) =>
		`url(${
			isDarkMode
				? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					lockScreenExperimentBackgroundDark
				: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					lockScreenExperimentBackground
		})`,
	backgroundPosition: 'top left',
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'cover',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LockScreenDialog = styled.div({
	maxWidth: '600px',
	borderRadius: token('border.radius.100', '3px'),
	backgroundColor: token('elevation.surface.overlay', N0),
	color: token('color.text', N900),
	boxShadow: token(
		'elevation.shadow.overlay',
		`0 0 0 1px ${N30A}, 0 2px 1px ${N30A}, 0 0 20px -6px ${N60A}`,
	),
	flex: 1,
});

const getBackgroundImageUrl = ({
	variation,
	isDarkMode,
}: {
	variation: string;
	isDarkMode?: boolean;
}) => {
	if (variation === 'danger') {
		return isDarkMode ? dangerBackgroundGridDark : dangerBackgroundGrid;
	}

	return isDarkMode ? warningBackgroundGridDark : warningBackgroundGrid;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CustomHeader = styled.div<{
	variation: string;
	isDarkMode?: boolean;
}>({
	width: '100%',
	height: '160px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundImage: (props) => `url(${getBackgroundImageUrl(props)})`,
	backgroundRepeat: 'no-repeat',
	justifyContent: 'center',
	alignItems: 'flex-end',
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CustomBody = styled.div({
	padding: `0 ${token('space.300', '24px')} ${token(
		'space.400',
		'32px',
	)} ${token('space.300', '24px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyLink = styled.a({
	color: token('color.text', N900),
	textDecoration: 'underline',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentContainer = styled.div({
	gap: token('space.300', '24px'),
	display: 'flex',
	flexDirection: 'column',
	padding: `${token('space.400', '32px')} 0 ${token('space.400', '32px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyHeading = styled.div({
	textAlign: 'center',
	fontSize: '20px',
	fontWeight: '500',
	lineHeight: '24px',
	fontColor: token('color.text', N900),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyText = styled.div({
	textAlign: 'center',
	fontSize: '14px',
	fontWeight: '400',
	lineHeight: '20px',
	fontColor: token('color.text', N900),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyListFrame = styled.div({
	maxWidth: '400px',
	margin: 'auto',
	padding: `${token('space.200', '16px')} ${token('space.200', '16px')} ${token(
		'space.200',
		'16px',
	)} ${token('space.200', '16px')}`,
	backgroundColor: token('color.background.accent.gray.subtlest', N30),
	textAlign: 'center',
	borderRadius: '8px',
	gap: token('space.100', '8px'),
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyListWrapper = styled.ul({
	listStyle: 'none',
	margin: '0 auto',
	padding: '0',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyListTitle = styled.div({
	fontSize: '14px',
	fontWeight: '600',
	lineHeight: '16px',
	fontColor: token('color.text', N900),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BodyListItem = styled.li({
	display: 'flex',
	fontSize: '14px',
	alignItems: 'center',
	gap: token('space.100', '8px'),
	color: token('color.text', N900),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonContainer = styled.div({
	justifyContent: 'center',
	display: 'flex',
	gap: token('space.100', '8px'),
	flexWrap: 'wrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SiteAdminSection = styled.div({
	justifyContent: 'center',
	display: 'flex',
	gap: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineDialogContentWrapper = styled.div({
	gap: token('space.100', '8px'),
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SiteAdminList = styled.ul({
	lineHeight: 1,
	paddingLeft: token('space.250', '20px'),
	margin: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LockScreenDialogActions = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flex: 1,
	marginBottom: token('space.500', '32px'),
});
